import React from "react";
import { useTripStore } from "../../store/useTripStore";
import MUITable from "../../../../../Common/MUITable";
import { useNavigate } from "react-router-dom";
import { TableLoader } from "../../../../../Common/ShimmerLoader";
import { ZoneWiseFilterForm } from "../../trips/filter_forms/ZoneWiseFilterForm";
import { ExportZoneWiseSATsReport } from "./ExportZoneWiseSATsReport";
import { formatDateTimeWithoutSec, getCurrentDateTime, getCurrentDateTime1 } from "../../../../../Common/helper/helpar";

export const ZoneWiseSATsReports = () => {
  const navigate = useNavigate();
  const {
    isFetchingZoneWiseTrips,
    zoneWiseTrips,
    fetchTripDetails,
    fetchCircleWiseTrips,
    fetchTotalTripDetails,
  } = useTripStore();

  const filters = JSON.parse(localStorage.getItem("sat-trips-zone-filters"));
  const zoneWiseHeaderColumns = [
    {
      label: "Zone",
      field: "zoneName",
      render: (row) => (
        <div
          style={{
            cursor: "pointer",
            color: `${row.zoneName === "Total" ? "black" : "blue"}`,
          }}
          onClick={() => {
            const params = {
              ...filters,
              ZoneId: row.zoneName === "Total" ? "" : row.zoneId,
            };
           
            fetchCircleWiseTrips(params);
            row.zoneName !== "Total" &&
              navigate("/sat-inner-circle-report", {
                state: { ...filters, colName: "Zone", zoneName: row.zoneName,zoneId:row.zoneId },
              });
          }}
        >
          {row.zoneName}
        </div>
      ),
    },
    {
      label: "Reported at TS/SCTP",
      field: "reportedatTSSCTP",
      render: (row) => (
        <div
          style={{ cursor: "pointer", color: "blue" }}
          onClick={() => {
            const params = {
              ...filters,
              TripTypeId: "5",
              isUnique: true,
              ZoneId: row.zoneName === "Total" ? "" : row.zoneId,
            };
            fetchTripDetails(params);
            navigate("/sat-inner-trip-report", {
              state: {
                ...filters,
                colName: "Reported at TS/SCTP",
                zoneName: row.zoneName,
              },
            });
          }}
        >
          {row.reportedatTSSCTP}
        </div>
      ),
    },
    {
      label: "Total Trips",
      field: "totalTrips",
      render: (row) => (
        <div
          style={{ cursor: "pointer", color: "blue" }}
          onClick={() => {
            const params = {
              ...filters,
              TripTypeId: "5",
              isUnique: false,
              ZoneId: row.zoneName === "Total" ? "" : row.zoneId,
            };
            fetchTripDetails(params);
            navigate("/sat-total-inner-trip-report", {
              state: {
                ...filters,
                colName: "Total Trips",
                zoneName: row.zoneName,
              },
            });
          }}
        >
          {row.totalTrips}
        </div>
      ),
    },
    {
      label: "1 Trip",
      field: "oneTrip",
      sortable: true,
      render: (row) => (
        <div
          style={{ cursor: "pointer", color: "blue" }}
          onClick={() => {
            const params = {
              ...filters,
              TripTypeId: "1",
              ZoneId: row.zoneName === "Total" ? "" : row.zoneId,
            };
            fetchTripDetails(params);
            navigate("/sat-inner-trip-report", {
              state: { ...filters, colName: "1 Trip", zoneName: row.zoneName },
            });
          }}
        >
          {row.oneTrip}
        </div>
      ),
    },
    {
      label: "2 Trips",
      field: "twoTrips",
      sortable: true,
      render: (row) => (
        <div
          style={{ cursor: "pointer", color: "blue" }}
          onClick={() => {
            const params = {
              ...filters,
              TripTypeId: "2",
              ZoneId: row.zoneName === "Total" ? "" : row.zoneId,
            };
            fetchTripDetails(params);
            navigate("/sat-inner-trip-report", {
              state: { ...filters, colName: "2 Trips", zoneName: row.zoneName },
            });
          }}
        >
          {row.twoTrips}
        </div>
      ),
    },
    {
      label: "3 Trips",
      field: "threeTrips",
      sortable: true,
      render: (row) => (
        <div
          style={{ cursor: "pointer", color: "blue" }}
          onClick={() => {
            const params = {
              ...filters,
              TripTypeId: "3",
              ZoneId: row.zoneName === "Total" ? "" : row.zoneId,
            };
            fetchTripDetails(params);
            navigate("/sat-inner-trip-report", {
              state: { ...filters, colName: "3 Trips", zoneName: row.zoneName },
            });
          }}
        >
          {row.threeTrips}
        </div>
      ),
    },
    {
      label: "Above 4 Trips",
      field: "above4Trips",
      render: (row) => (
        <div
          style={{ cursor: "pointer", color: "blue" }}
          onClick={() => {
            const params = {
              ...filters,
              TripTypeId: "4",
              ZoneId: row.zoneName === "Total" ? "" : row.zoneId,
            };
            fetchTripDetails(params);
            navigate("/sat-inner-trip-report", {
              state: {
                ...filters,
                colName: "Above 4 Trips",
                zoneName: row.zoneName,
              },
            });
          }}
        >
          {row.above4Trips}
        </div>
      ),
    },
    {
      label: "Quantity in MT(Est)",
      field: "quantityinMTEst",
      render: (row) => row.quantityinMTEst,
    },
  ];

  const storedFilters = JSON.parse(localStorage.getItem("sat-trips-zone-filters")) || {};
  // const defaultFilters = {
  //   FromDateTime: storedFilters.FromDateTime || currentDateWithStartTime,
  //   ToDateTime: storedFilters.ToDateTime || currentDateTime,
  //   OwnerTypeId: storedFilters.OwnerTypeId || "", // Ensure OwnerTypeId is set
  // };
  return (
    <div>
      <div className="top-header page-title">
        <span>Zone Wise SATs Reports as on ({storedFilters.FromDateTime ? formatDateTimeWithoutSec(storedFilters.FromDateTime) : getCurrentDateTime()} To { storedFilters.ToDateTime ? formatDateTimeWithoutSec(storedFilters.ToDateTime) : getCurrentDateTime()}) (at {getCurrentDateTime1()})</span>
        {/* <span>{state.zoneName} Zone, Circles wise SATs Trips to TS/SCTP ({formatDateTimeWithoutSec(state.FromDateTime)} To {formatDateTimeWithoutSec(state.ToDateTime)})</span> */}

      </div>
      <div className="card mt-3">
        <div className="">
          <ZoneWiseFilterForm />
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "-40px",
              marginBottom: "10px",
            }}
          >
            <ExportZoneWiseSATsReport />
          </div>
          <MUITable
            hasTotalRow={true}
            needSRNumber
            columns={zoneWiseHeaderColumns}
            rows={zoneWiseTrips}
            tableHeight={500}
          />
        </div>
      </div>
    </div>
  );
};
